<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>
        {{ $t("subscriptionToUpgradeTo") }} <span class="text-danger">*</span>
      </template>
      <b-form-select :options="subscriptionPlanOptions" @change="chooseSubscription" v-model="subscriptionPlanId" required />
    </b-form-group>
<!--    <b-form-group>
      <template v-slot:label>{{ $t("startDate") }} <span class="text-danger">*</span></template>
      <b-form-datepicker v-model="startDate" required
                         :min="new Date()" :max="startDateMaxValue"
                         no-flip hide-header
                         label-no-date-selected="DD/MM/YYYY"
                         locale="vi"
                         :date-format-options="datePickerFormatOptions"
                         start-weekday="1"></b-form-datepicker>
    </b-form-group>-->
    <b-form-group :label="$t('upgradeOption')">
      <b-form-radio-group required :options="upgradeOptions" v-model="upgradeOption" />
    </b-form-group>
    <b-form-group  v-if="subscriptionPlanId">
      <template v-slot:label>
        {{ $t("numberOfConcurrentMeetings") }}
      </template>
      <b-form-input v-model="numberOfConcurrentMeetings" type="number" required />
    </b-form-group>
    <b-form-group v-if="subscriptionPlanId && upgradeOption === 1">
      <template v-slot:label>
        {{ $t("upgradeDurationExtension", { unit: selectedSubscriptionPlan.unitTimeVN }) }} <span class="text-danger">*</span>
      </template>
      <b-form-input v-model="numOfMonth" type="number" min="1" max="32" required />
    </b-form-group>

    <p class="text-secondary">{{ $t("upgradeConfirmCorrectInfo") }}</p>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right mt-4">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("upgradeService") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import moment from "moment";
  import BaseComponent from "@/components/BaseComponent";
  import * as subscriptionPlanService from "@/service/subscriptionPlanService";
  import * as customerService from "@/service/customerService";

  @Component
  export default class UpgradeSubscriptionModal extends BaseComponent {

    datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

    @Prop({ required: true }) customerSubscription;

    subscriptionPlans = [];
    subscriptionPlanId: number = null;
    startTime: string = null;

    startDate: string = null;
    startDateMaxValue: string = null;

    upgradeOption = 0;
    upgradeOptions = [
      { value: 0, text: this.$t("upgradeOption0").toString() },
      { value: 1, text: this.$t("upgradeOption1").toString() },
    ];

    numOfMonth: number | string = 1;

    numberOfConcurrentMeetings = 0;

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {
      this.startDate = moment().format("YYYY-MM-DD");
      this.startDateMaxValue = moment(this.customerSubscription.endTime).format("YYYY-MM-DD");

      this.fetchSubscriptionPlans();
    }

    async fetchSubscriptionPlans() {
      try {
        this.subscriptionPlans = await subscriptionPlanService.getPlans();
        /*const allSubscriptionPlans = await subscriptionPlanService.getPlans();
        const currentPlan = allSubscriptionPlans.find(it => it.id === this.customerSubscription.subscriptionPlanId);

        // Packages available to upgrades
        this.subscriptionPlans = allSubscriptionPlans.filter(it =>
          it.id !== currentPlan.id && (
            it.price > currentPlan.price || it.numberOfDaysUsage > currentPlan.numberOfDaysUsage
          )
        );*/

      } catch (e) {
        this.toastError(e);
      }
    }

    get subscriptionPlanOptions() {
      const options: any[] = this.subscriptionPlans.map(it => ({
        value: it.id,
        text: it.name + " - " + this.formatCurrencyAmount(it.price) + " VND / " + it.numberOfDaysUsage + ' ' + it.unitTimeVN,
      }));
      options.unshift({ text: this.$t("chooseSubscription").toString(), value: null, disabled: true });
      return options;
    }

    get selectedSubscriptionPlan() {
      return this.subscriptionPlans.find(it => it.id === this.subscriptionPlanId);
    }

    onClickCancel() {
      this.$bvModal.hide("upgrade-subscription-modal");
    }

    chooseSubscription(id) {
      this.numberOfConcurrentMeetings = this.subscriptionPlans.find(it => it.id === id).numberOfConcurrentMeetings;
    }

    async submitForm() {
      const data = {
        dateStartToUpgrade: moment.utc(this.startDate, "YYYY-MM-DD", true).toISOString(),
        upgradeOption: this.upgradeOption,
        numOfMonth: this.upgradeOption > 0 ? this.numOfMonth : 0,
        customerSubscriptionId: this.customerSubscription.id,
        newSubPlanId: this.subscriptionPlanId,
        numberOfConcurrentMeetings: +this.numberOfConcurrentMeetings
      };

      try {
        this.isSubmitting = true;
        await customerService.upgradeSubscription(data);

        this.__submitted();
        this.$bvModal.hide("upgrade-subscription-modal");
        this.toastSuccessDelay(this.$t("upgradeServiceSuccessful").toString());

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
